/**
 * @generated SignedSource<<ed2133031f68fa6b7961a5c5495832aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignPointsToUserInput = {
  amount: number;
  clientMutationId?: string | null;
  contentId: string;
  rootId: string;
  userId: string;
};
export type userRootNodeItemTreeItem_AssignPointsToUserMutation$variables = {
  input: AssignPointsToUserInput;
};
export type userRootNodeItemTreeItem_AssignPointsToUserMutation$data = {
  readonly Admin: {
    readonly GamificationPoints: {
      readonly assignPointsToUser: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type userRootNodeItemTreeItem_AssignPointsToUserMutation = {
  response: userRootNodeItemTreeItem_AssignPointsToUserMutation$data;
  variables: userRootNodeItemTreeItem_AssignPointsToUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GamificationPointsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "GamificationPoints",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AssignPointsToUserPayload",
            "kind": "LinkedField",
            "name": "assignPointsToUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userRootNodeItemTreeItem_AssignPointsToUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userRootNodeItemTreeItem_AssignPointsToUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab796d9ae8ec428b7e44c32065d9d91f",
    "id": null,
    "metadata": {},
    "name": "userRootNodeItemTreeItem_AssignPointsToUserMutation",
    "operationKind": "mutation",
    "text": "mutation userRootNodeItemTreeItem_AssignPointsToUserMutation(\n  $input: AssignPointsToUserInput!\n) {\n  Admin {\n    GamificationPoints {\n      assignPointsToUser(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52bb60ec621d11d1af0f86e0db7c3579";

export default node;
